/** Burgundy header used in CRM sidebar and public intake shell */
export const CM_BRAND_BAR_BG = 'rgb(141, 35, 52)'

export const CM_EMBLEM_SRC = '/cm-emblem.svg'
export const CM_FIRM_NAME_SRC = '/cm-firm-name.svg'
